import React from 'react'

// Components
import CounselorForm from '../../../../components/user/join-form/Counselor'

const CounselorSocial = () => {
   return (
      <CounselorForm isSocial={true} />
   )
}

export default CounselorSocial